/* @ngInject */

const SrvAdministracion = function ($uibModal, $window, apiCall, mostrarNotificacion) {

    this.ModalEditarColaborador = (roles, data) => {
  
        return $uibModal.open({
            template: require('../../../../app/views/Administracion/Cuentas/Colaboradores/EditarColaborador_modal.html'),
            windowClass: 'modal--small',
            appendTo: angular.element(document.querySelector('.modal-parent')),          
            controller: ($scope, $uibModalInstance) => {

                if (angular.isArray(roles)) {
                    $scope.roles = roles;
                }

                $scope.data = data;        

                $scope.editarColaborador = () => {

                    const datos = {
                        CveContribuyente: data.ClaveContribuyente,
                        CveUsuario: data.ClaveUsuario,
                        CveTipoUsuario: $scope.data.CveTipoUsuario
                    };

                    $scope.loading = true;
                    apiCall.post("EditarColaborador", datos)
                        .then(data => {
                            if (data.EsError) {
                                $scope.alert = [{
                                    msg: data.Mensaje,
                                    type: "error"
                                }];
                            } else {
                                mostrarNotificacion.info("Se actualizó el usuario colaborador exitosamente.");
                                $scope.closeModal(data);
                            }

                        }, error => {
                            $scope.alert = [{
                                msg: "Hubo un error al editar el usuario colaborador.",
                                type: "error"
                            }];
                        })
                        .finally(() => $scope.loading = false);
                };

                $scope.closeModal = $uibModalInstance.close;

                $scope.closeModalAlert = () => $scope.alert = [];

            }
        });
    };

    this.ModalDesactivarColaborador = (data) => {

        return $uibModal.open({
            template: require('../../../../app/views/Administracion/Cuentas/Colaboradores/EliminarColaborador_modal.html'),
            windowClass: 'modal--small',
            appendTo: angular.element(document.querySelector('.modal-parent')),
            controller: ($scope, $uibModalInstance) => {

                console.log(data);
                $scope.data = data;

                $scope.desactivarColaborador = () => {

                    const datos = {
                        CveContribuyente: data.CveContribuyente,
                        CveUsuario: data.CveUsuario
                    };

                    $scope.loading = true;
                    apiCall.post("EliminarColaborador", datos)
                        .then(data => {
                            if (data.EsError) {
                                $scope.alert = [{
                                    msg: data.Mensaje,
                                    type: "error"
                                }];
                            } else {
                                mostrarNotificacion.info("Se actualizó el usuario colaborador exitosamente.");
                                $scope.closeModal(data);
                            }

                        }, error => {
                            $scope.alert = [{
                                msg: "Hubo un error al desactivar el usuario colaborador.",
                                type: "error"
                            }];
                        })
                        .finally(() => $scope.loading = false);
                };

                $scope.closeModal = $uibModalInstance.close;

                $scope.closeModalAlert = () => $scope.alert = [];

            },
        });
    };

};

export default SrvAdministracion;
